/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Upkeep_AnswerInputs */

const en_faq_upkeep_answer = /** @type {(inputs: Faq_Upkeep_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We agree on ownership, monitoring and maintenance before launch. Ongoing work can include investigating failures, improving quality and adapting the system as your business changes.`)
};

const lv_faq_upkeep_answer = /** @type {(inputs: Faq_Upkeep_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par atbildību, uzraudzību un uzturēšanu vienojamies pirms ieviešanas. Turpmākais darbs var ietvert kļūmju izmeklēšanu, kvalitātes uzlabošanu un sistēmas pielāgošanu, mainoties Jūsu uzņēmumam.`)
};

/**
* | output |
* | --- |
* | "We agree on ownership, monitoring and maintenance before launch. Ongoing work can include investigating failures, improving quality and adapting the system a..." |
*
* @param {Faq_Upkeep_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_upkeep_answer = /** @type {((inputs?: Faq_Upkeep_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Upkeep_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_upkeep_answer(inputs)
	return en_faq_upkeep_answer(inputs)
});